import { gql } from '@apollo/client'

export const FIELD_CREATE_MUTATION = gql`
  mutation FIELD_CREATE_MUTATION($input: FieldInput!) {
    fieldCreate(input: $input) {
      ok
      data {
        id
      }
    }
  }
`

export const FIELD_UPDATE_MUTATION = gql`
  mutation FIELD_UPDATE_MUTATION($id: ID!, $input: FieldInput!) {
    fieldUpdate(id: $id, input: $input) {
      ok
      data {
        options {
          id
          active
          label
          value
        }
      }
    }
  }
`

export const FIELD_DELETE_MUTATION = gql`
  mutation FIELD_DELETE_MUTATION($id: ID!) {
    fieldDelete(id: $id) {
      ok
    }
  }
`

export const FIELD_UPDATE_POSITIONS_MUTATION = gql`
  mutation FIELD_UPDATE_POSITIONS_MUTATION($input: [FieldUpdatePositionInput!]) {
    fieldUpdatePositions(input: $input) {
      ok
    }
  }
`

export const OBJECT_ENTITY_UPDATE_MUTATION = gql`
  mutation OBJECT_ENTITY_UPDATE_MUTATION($id: ID!, $input: ObjectEntityUpdateInput!) {
    objectEntityUpdate(id: $id, input: $input) {
      data {
        id
      }
    }
  }
`

export const FIELD_VALUE_UPSERT_MUTATION = gql`
  mutation FIELD_VALUE_UPSERT_MUTATION($entityId: ID!, $input: [FieldValueInput!]!) {
    fieldValueUpsert(entityId: $entityId, input: $input) {
      id
      fieldId
      createdAt
      value
      linkedFieldValue {
        fieldValueId
        fieldValue
        fieldName
        fieldType
      }
    }
  }
`

export const FIELD_VALUE_UPSERT_PB_MUTATION = gql`
  mutation FIELD_VALUE_UPSERT_PB_MUTATION($domain: String!, $entityId: ID!, $input: [FieldValueInput!]!) {
    fieldValueUpsertPublic(domain: $domain, entityId: $entityId, input: $input) {
      id
      fieldId
      createdAt
      value
      linkedFieldValue {
        fieldValueId
        fieldValue
        fieldName
        fieldType
      }
    }
  }
`

export const FIELD_VALUE_DELETE_MUTATION = gql`
  mutation FIELD_VALUE_DELETE_MUTATION($ids: [ID!]!) {
    fieldValueDelete(ids: $ids) {
      ok
    }
  }
`

export const FIELD_VALUE_SET_ARCHIVED_MUTATION = gql`
  mutation FIELD_VALUE_SET_ARCHIVED_MUTATION($ids: [ID!]!, $archived: Boolean!) {
    fieldValueSetArchived(ids: $ids, archived: $archived) {
      ok
    }
  }
`

export const FIELD_VALUE_DELETE_PB_MUTATION = gql`
  mutation FIELD_VALUE_DELETE_PB_MUTATION($domain: String!, $ids: [ID!]!) {
    fieldValueDeletePublic(domain: $domain, ids: $ids) {
      ok
    }
  }
`
